import { render, staticRenderFns } from "./InvoicePromotion.vue?vue&type=template&id=72ccaaea&scoped=true&"
import script from "./InvoicePromotion.vue?vue&type=script&lang=js&"
export * from "./InvoicePromotion.vue?vue&type=script&lang=js&"
import style0 from "./InvoicePromotion.vue?vue&type=style&index=0&id=72ccaaea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ccaaea",
  null
  
)

export default component.exports